const GalleryItems = [


    {
        src: require("../srcAssets/images/galleryPhotos/colorCloseField.jpg"),
        width: 3000,
        height: 2002,
        alt: "Color Close Field",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/colorField.jpg"),
        width: 3000,
        height: 2002,
        alt: "Color Field",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    // {
    //     src: require("../srcAssets/images/galleryPhotos/colorPortrait-Edit.jpg"),
    //     width: 2002,
    //     height: 2002,
    //     alt: "Cropped Color Portrait",
    //     photographer: 'Lenny Gonzalez'
    // },
    {
        src: require("../srcAssets/images/galleryPhotos/colorPortrait.jpg"),
        width: 2002,
        height: 3000,
        alt: "Full Color Portrait",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/colorRoad.jpg"),
        width: 2002,
        height: 3000,
        alt: "Color Road",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/colorStreeWalk.jpg"),
        width: 3000,
        height: 2002,
        alt: "Color Street Walking",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/colorTree.jpg"),
        width: 2002,
        height: 3000,
        alt: "Color Tree Portrait",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/grey_closeField.jpg"),
        width: 3000,
        height: 2002,
        alt: "Grey Close Field",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/greyField.jpg"),
        width: 3000,
        height: 2002,
        alt: "Grey Field",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/greyPortrait.jpg"),
        width: 2002,
        height: 3000,
        alt: "Grey Portrait",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/greyRoad.jpg"),
        width: 2002,
        height: 3000,
        alt: "Grey Road",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/greyTree.jpg"),
        width: 2002,
        height: 3000,
        alt: "Grey Tree",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/walking grey.jpg"),
        width: 3000,
        height: 2002,
        alt: "Walking Grey",
        photographer: 'Lenny Gonzalez',
        description: 'Photo by Lenny Gonzalez'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkBow.jpg"),
        width: 1600,
        height: 2413,
        alt: "Mark Session Bow",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkMarimba.jpg"),
        width: 1624,
        height: 1600,
        alt: "Mark Session Marimba",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkMarimba2.jpg"),
        width: 1624,
        height: 1600,
        alt: "Mark Session Marimba 2",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkSessionPercussion.jpg"),
        width: 1624,
        height: 1600,
        alt: "Mark Session Percussion",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkSessionVibes.jpg"),
        width: 1600,
        height: 2413,
        alt: "Mark Session Vibes",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },
    {
        src: require("../srcAssets/images/galleryPhotos/MarkSessionPiano.jpg"),
        width: 1600,
        height: 2413,
        alt: "Mark Session Piano",
        photographer: 'Ginger Fierstein',
        description: 'Photo by Ginger Fierstein'
    },

]

export default GalleryItems;